import React from 'react';
import useMultiLanguageContext from '../../MultiLanguageContext/useMultiLanguageContext';
import useSessionInfo from './useSessionInfo';

export default function useSessionLanguage() {
  const session = useSessionInfo();
  const { language } = useMultiLanguageContext();

  const value = React.useMemo(() => {
    if (language) {
      const sessionTranslation = session?.project.translations?.find((t) => t.language === language);
      if (sessionTranslation) {
        return sessionTranslation.language;
      }
    }
    return session?.project.asrLanguage;
  }, [language, session?.project]);

  return value;
}
